import "./App.scss";

import {
  Header,
  About,
  Work,
  Skills,
  Testimonials,
  Contact,
} from "./container/index";

import { Navbar } from "./components/index";

function App() {
  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Contact />
    </div>
  );
}

export default App;
